import { render, staticRenderFns } from "./MyLightBox.vue?vue&type=template&id=10aa9422&scoped=true&"
import script from "./MyLightBox.vue?vue&type=script&lang=js&"
export * from "./MyLightBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10aa9422",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10aa9422')) {
      api.createRecord('10aa9422', component.options)
    } else {
      api.reload('10aa9422', component.options)
    }
    module.hot.accept("./MyLightBox.vue?vue&type=template&id=10aa9422&scoped=true&", function () {
      api.rerender('10aa9422', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/commonComponent/MyLightBox.vue"
export default component.exports